'use client';

import React from 'react';
import Container from '@mui/material/Container';
import FirstScreen from './first-screen';
import SecondScreen from './second-screen';
import ResumeEvaluation from './resume-evaluation';
import ResumeEdit from '@/components/resume/resume-marketing/ResumeEdit';
import ConsultClassify from '@/components/resume/resume-marketing/ConsultClassify';
import SearchArea from '../search/SearchArea';
import HotJobsSalaryRank from './HotJobsSalaryRank';
import RecommendPosts, { PostType } from './RecommendPost';
import HobJobsSalary from './HotJobsSalary';
import HotJobOpportunity, {
  GroupedHotJobOpportunitiesType,
} from './HotJobOpportunity';
import HotCities from './HotCities';
import { HotCitiesType } from '@/components/city/CityCard';
import { HotJobsSalaryType } from '@/app/page';
import { JobOpenDetailsType } from '@/context/job-title';
import { getHomePagePosts } from '@/utils/articles';

export type HotJobTitlesType = {
  category_id: string;
  category_name: string;
  job_titles: {
    id: string;
    name: string;
    salary: number;
    description: string;
    job_open_details: JobOpenDetailsType;
  }[];
}[];

interface Props {
  hotJobTitles: HotJobTitlesType;
  hotJobOpportunities: GroupedHotJobOpportunitiesType;
  hotJobsSalary: HotJobsSalaryType[];
  hotCities: HotCitiesType[];
}

const HomePage = (props: Props) => {
  const { hotJobTitles, hotJobOpportunities, hotJobsSalary, hotCities } = props;

  const [posts, setPosts] = React.useState<PostType[]>([]);

  React.useEffect(() => {
    getHomePagePosts().then((data) => {
      if (data && data.length > 0) {
        setPosts(data);
      }
    });
  }, []);

  return (
    <>
      <FirstScreen />
      <SecondScreen />
      <ResumeEvaluation />
      <ResumeEdit />
      <ConsultClassify isConsultationBtnLink={true} />
      <SearchArea hotJobTitles={hotJobTitles} />
      <Container maxWidth="desktop">
        <HobJobsSalary hotJobTitles={hotJobTitles} />
        <HotJobOpportunity data={hotJobOpportunities} />
        <HotCities hotCities={hotCities} />
        <HotJobsSalaryRank hotJobsSalary={hotJobsSalary} />
        <RecommendPosts posts={posts} />
      </Container>
    </>
  );
};

export default HomePage;
